import ReviewImage1 from "../../../../Assets/img/review-1.jpg";
import ReviewImage2 from "../../../../Assets/img/review-2.jpg";
import ReviewImage3 from "../../../../Assets/img/review-3.jpg";

export const Reviews = [
  {
    review:
      "We have been using Pavelify and it seems to be one of the best addition we did to our business this year. The crazy thing is that it is free. Our team and business is more organized and we have seen our customers love us more ",
    img: ReviewImage1,
    name: "Victor E",
    belowName: "Director of Growth at Conterize"
  },
  {
    review:
      "Since we switched to Pavelify, we have seen tremendous growth in our business. We have achieved higher customer satisfaction. Sales has went up not to mention that it's very easy to set and use. We like the analytics and reporting tool  btw, it helps us to keep track of how our business is performing.",
    img: ReviewImage2,
    name: "Elvis R.",
    belowName: "Customer Support Manager at IncorpUK"
  },
  {
    review:
      "Pavelify has completely unified our customer support and sales team. Support is top notch. If we have gotten most of their features from other platforms we would have been spending more money per year. The free live chat, ticketing and appointment scheduling has been so great for our business. ",
    img: ReviewImage3,
    name: "Betty A",
    belowName: "VP  Marketing  at AZ Media"
  },
  {
    review:
      "We have been using Pavelify and it seems to be one of the best addition we did to our business this year. The crazy thing is that it is free. Our team and business is more organized and we have seen our customers love us more ",
    img: ReviewImage1,
    name: "Victor E",
    belowName: "Director of Growth at Conterize"
  },
  {
    review:
      "Since we switched to Pavelify, we have seen tremendous growth in our business. We have achieved higher customer satisfaction. Sales has went up not to mention that it's very easy to set and use. We like the analytics and reporting tool  btw, it helps us to keep track of how our business is performing.",
    img: ReviewImage2,
    name: "Elvis R.",
    belowName: "Customer Support Manager at IncorpUK"
  },
  {
    review:
      "Pavelify has completely unified our customer support and sales team. Support is top notch. If we have gotten most of their features from other platforms we would have been spending more money per year. The free live chat, ticketing and appointment scheduling has been so great for our business. ",
    img: ReviewImage3,
    name: "Betty A",
    belowName: "VP  Marketing  at AZ Media"
  }
];
